import type { MapMarkerRole } from './types';

/** Orange bus icon for live vehicle tracking (SVG data URI). */
export const BUS_MARKER_ICON_URL =
  'data:image/svg+xml,' +
  encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
  <circle cx="20" cy="20" r="18" fill="#FA8C16" stroke="#fff" stroke-width="2"/>
  <rect x="10" y="13" width="20" height="12" rx="2" fill="#fff"/>
  <rect x="12" y="15" width="5" height="4" rx="0.5" fill="#FA8C16"/>
  <rect x="19" y="15" width="5" height="4" rx="0.5" fill="#FA8C16"/>
  <rect x="26" y="15" width="2" height="4" rx="0.5" fill="#FA8C16"/>
  <circle cx="14" cy="27" r="2.5" fill="#fff" stroke="#FA8C16" stroke-width="1"/>
  <circle cx="26" cy="27" r="2.5" fill="#fff" stroke="#FA8C16" stroke-width="1"/>
</svg>`);

/** Intrinsic pixel size of stop (pickup/drop-off) pin SVGs. */
export const STOP_MARKER_SIZE = { width: 40, height: 52 } as const;

/** Tip of the pin in SVG space — use as Google Marker Anchor origin. */
export const STOP_MARKER_ANCHOR = { x: 20, y: 50 } as const;

function stopPinSvg(fill: string, letter: string): string {
  return `
<svg xmlns="http://www.w3.org/2000/svg" width="40" height="52" viewBox="0 0 40 52">
  <ellipse cx="20" cy="49" rx="7" ry="2.8" fill="#0F172A" opacity="0.28"/>
  <path d="M20 50C20 50 3.5 33 3.5 18.5a16.5 16.5 0 1 1 33 0C36.5 33 20 50 20 50z"
        fill="${fill}" stroke="#FFFFFF" stroke-width="2.75"/>
  <circle cx="20" cy="18.5" r="11.5" fill="#FFFFFF"/>
  <text x="20" y="23.5" text-anchor="middle"
        font-family="Arial,Helvetica,sans-serif" font-size="15" font-weight="700"
        fill="${fill}">${letter}</text>
</svg>`.trim();
}

/** Large green pin with letter P — designed to stay visible on dense basemaps. */
export const PICKUP_MARKER_ICON_URL =
  'data:image/svg+xml,' + encodeURIComponent(stopPinSvg('#059669', 'P'));

/** Large red pin with letter D. */
export const DROPOFF_MARKER_ICON_URL =
  'data:image/svg+xml,' + encodeURIComponent(stopPinSvg('#DC2626', 'D'));

export const MARKER_COLORS: Record<MapMarkerRole, string> = {
  pickup: '#059669',
  dropoff: '#DC2626',
  vehicle: '#F59E0B',
  driver: '#2563EB',
  track: '#EA580C',
};

export function isBusMarkerRole(role?: MapMarkerRole): boolean {
  return role === 'vehicle';
}

export function isStopMarkerRole(role?: MapMarkerRole): role is 'pickup' | 'dropoff' {
  return role === 'pickup' || role === 'dropoff';
}

export function stopMarkerIconUrl(role: 'pickup' | 'dropoff'): string {
  return role === 'pickup' ? PICKUP_MARKER_ICON_URL : DROPOFF_MARKER_ICON_URL;
}

/** Marker stacking — stops above track crumbs; vehicle near stops. */
export function markerZIndex(role?: MapMarkerRole): number {
  switch (role) {
    case 'pickup':
    case 'dropoff':
      return 140;
    case 'vehicle':
    case 'driver':
      return 130;
    case 'track':
      return 20;
    default:
      return 50;
  }
}
